"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentPlacement = void 0;
var CommentPlacement;
(function (CommentPlacement) {
    CommentPlacement["Comments"] = "comments";
    CommentPlacement["CommentsInline"] = "comments_inline";
})(CommentPlacement = exports.CommentPlacement || (exports.CommentPlacement = {}));
